"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccordionProperty = exports.accordionPropertyDefinition = void 0;
exports.accordionPropertyDefinition = {
    view: { label: 'Accordion' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['accordion-title', 'accordion-blocks'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'accordion',
};
const isAccordionProperty = (prop) => {
    return prop.name === exports.accordionPropertyDefinition.name;
};
exports.isAccordionProperty = isAccordionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYWNjb3JkaW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMkJBQTJCLEdBQUc7SUFDekMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRTtJQUM1QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFLENBQUMsaUJBQWlCLEVBQUUsa0JBQWtCLENBQUM7U0FDbEQ7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsV0FBVztDQUNjLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==